<template>
  <div>
    <div class="wrap1200 breadcrumb">
      <breadcrumb></breadcrumb>
    </div>

    <div class="toolMain wrap1200">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="剔除号码" name="first">
          <removeNum v-show="activeName === 'first'" />
        </el-tab-pane>

        <el-tab-pane label="胆拖组合" name="second">
          <dragNum v-show="activeName === 'second'" />
        </el-tab-pane>

        <el-tab-pane label="旋转矩形组号" name="third">
          <rotatRectangle v-show="activeName === 'third'" />
        </el-tab-pane>

        <el-tab-pane label="历史数据推荐" name="fourth">
          <historyData v-show="activeName === 'fourth'" />
        </el-tab-pane>

        <el-tab-pane label="号码跟随" name="fiveth">
          <numFollow v-show="activeName === 'fiveth'" />
        </el-tab-pane>

        <el-tab-pane label="跨度筛选" name="sixth">
          <SpanFilter v-show="activeName === 'sixth'" />
        </el-tab-pane>
        <!-- <el-tab-pane label="和值筛选" name="seventh">
          <HeZhiFilter v-show="activeName === 'seventh'" />
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue';
import removeNum from './usingTools/removeNum.vue';
import dragNum from './usingTools/dragNum.vue';
import rotatRectangle from './usingTools/rotatRectangle.vue';
import historyData from './usingTools/historyData.vue';
import numFollow from './usingTools/numFollow.vue';
import SpanFilter from './usingTools/spanFilter.vue';
import HeZhiFilter from './usingTools/hezhiFilter.vue';
export default {
  name: 'Tool',
  components: {
    Breadcrumb,
    removeNum,
    dragNum,
    rotatRectangle,
    historyData,
    numFollow,
    SpanFilter,
    HeZhiFilter
  },
  data() {
    return {
      activeName: 'first' // 默认激活第一个tab
    };
  },
  methods: {
    handleClick(tab) {
      console.log('当前标签:', tab.name);
    }
  }
};
</script>

<style>
.wrap1200 {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.toolMain {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  min-height: 450px;
}
</style>



// WEBPACK FOOTER //
// src/views/tool.vue